export default __webpack_public_path__ + "static/media/logo.6c2c7b7e.png";